/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PdfDownloadResponse
 */
export interface PdfDownloadResponse {
    /**
     * Signed URL to download the combined PDF
     */
    download_url?: string;
}

/**
 * Check if a given object implements the PdfDownloadResponse interface.
 */
export function instanceOfPdfDownloadResponse(value: object): value is PdfDownloadResponse {
    return true;
}

export function PdfDownloadResponseFromJSON(json: any): PdfDownloadResponse {
    return PdfDownloadResponseFromJSONTyped(json, false);
}

export function PdfDownloadResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PdfDownloadResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'download_url': json['download_url'] == null ? undefined : json['download_url'],
    };
}

export function PdfDownloadResponseToJSON(json: any): PdfDownloadResponse {
    return PdfDownloadResponseToJSONTyped(json, false);
}

export function PdfDownloadResponseToJSONTyped(value?: PdfDownloadResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'download_url': value['download_url'],
    };
}

